import { assertFetchGetActiveTypesResponse } from './asserts';
import { prepareInfrastructureTypes } from '../../../Map/mappers/infrastructure';
import {
  fetchGetActiveTypesByBbox,
  IGetActiveTypesByBboxRequest,
  TGetActiveTypesByBboxResponse,
} from '../../repositories/infrastructure-caching/v1/get-active-types-by-bbox';
import { IApplicationContext } from '../../types/applicationContext';
import { IInfrastructureType } from '../../types/infrastructure';

export async function fetchInfrastructureTypesByBbox(
  parameters: IGetActiveTypesByBboxRequest,
  context: IApplicationContext,
): Promise<IInfrastructureType[]> {
  try {
    const res: TGetActiveTypesByBboxResponse = await fetchGetActiveTypesByBbox({
      httpApi: context.httpApi,
      parameters,
    });

    assertFetchGetActiveTypesResponse(res);

    return prepareInfrastructureTypes(res);
  } catch (e) {
    context.logger.warning(e, {
      domain: 'fetchInfrastructureTypesByBbox',
      degradation: 'Типы дополнительных слоев',
    });

    return [];
  }
}
